<div class="flex flex-column flex-justify-between height-100">
    <div>
        @if (product && product.data) {
        <div class="pos-relative z-1 product-gallery"
             [scrollNavTarget]="'Gallery' | translate">
            <!-- gallery XL -->
            <ng-container *ifSize="'XL'">
                @for (row of mediaRows; track $index; let lastRow = $last; let i = $index) {
                <div class="flex"
                     [class.p-b]="!lastRow">
                    @for (item of row; track $index; let lastItem = $last; let j = $index) {
                    <div class="overflow-hidden product-image-gallery-container overflow-hidden"
                         [class._disabled]="product.isSoldOut"
                         [ngClass]="[item.classes, 'photoswipe-galleryuid-' + product.data.id]">
                        <shell></shell>
                        <!-- img -->
                        <!-- 3D Viewer iframe overlay -->
                        @if (item.iframeSrc) {
                        <div class="fill z-10"
                             [photoswipe]="item.image"
                             [photoswipeHtml]="getIframeHtml(item)"
                             [photoswipeThumbnail]="item.image"
                             [photoswipeUid]="item.image + '.' + product.data.id + '.' + i + '.' + j"
                             [photoswipeOptions]="{
                                                        index: i * 1000  + j,
                                                        galleryUID: product.data.id
                                                    }">
                            <iframe class="fill"
                                    [src]="item.iframeSrcSafe"
                                    frameborder="0"
                                    (iframeFocus)="handle3DViewerFocus(item)">
                            </iframe>
                        </div>
                        } @else {
                        @if (!item.video) {
                        <img class="fill"
                             [ratio]="item.ratio"
                             [dfImage]="item.image"
                             [attr.alt]="product.data.name"
                             [photoswipe]="item.image"
                             [photoswipeUid]="item.image + '.' + product.data.id + '.' + i + '.' + j"
                             [photoswipeOptions]="{
                                                    index: i * 1000  + j,
                                                    galleryUID: product.data.id
                                                }">

                        }
                        @if (item.video) {
                        <vimeo-player [video-url]="item.video"
                                      [background]="true"
                                      class="bg-col-w"
                                      [autoplay-in-viewport]="true"
                                      [loop]="true">
                        </vimeo-player>
                        }
                        @if (item.alt_text) {
                        <p class="p-t-2 bg-col-w p3 _altText">{{item.alt_text}}</p>
                        }
                        @if(item.shopTheLook) {
                        <shop-this-look [content]="{
                            shopThisLookTop: true,
                            shopThisLookLeft: false,
                            shopThisLookProductsSkus: item.shopTheLook
                        }"></shop-this-look>
                        }
                        }
                    </div>
                    }
                </div>
                }
            </ng-container>
            <!-- gallery MS -->
            <div *ifSize="'MS'"
                 class="pos-relative p-b-7">
                <div class="pos-relative overflow-hidden">
                    <shell></shell>
                    <swiper [slidesPerView]="'auto'"
                            [spaceBetween]="16"
                            [pagination]="true"
                            [freeMode]="true"
                            imageViewRoot
                            (afterInit)="onAfterInit($event)"
                            #swiper>
                        @for (productImage of mediaMobile; track $index; let i = $index) {
                        <ng-template swiperSlide
                                     [class]="productImage.isLandscape ? 'landscape' : ''">
                            <div [class._disabled]="product.isSoldOut"
                                 [ngClass]="[productImage.isLandscape ? 'ratio-16-9' : 'ratio-3-4', 'photoswipe-galleryuid-' + product.data.id]">

                                <!-- 3D Viewer iframe overlay -->
                                @if (productImage.iframeSrc) {
                                <iframe class="fill z-10"
                                        [src]="productImage.iframeSrcSafe"
                                        frameborder="0"
                                        [photoswipe]="productImage.image"
                                        [photoswipeHtml]="getIframeHtml(productImage)"
                                        [photoswipeThumbnail]="productImage.image"
                                        [photoswipeUid]="productImage.image + '.' + product.data.id + '.' + i"
                                        [photoswipeOptions]="{
                                                        index: i,
                                                        galleryUID: product.data.id
                                                    }"
                                        (iframeFocus)="handle3DViewerFocus(productImage)">
                                </iframe>
                                } @else {
                                @if (!productImage.video) {
                                <img class="fill"
                                     [ratio]="productImage.isLandscape ? 9/16 : 4/3"
                                     [dfImage]="productImage.image"
                                     [photoswipe]="productImage.image"
                                     [photoswipeUid]="productImage.image + '.' + product.data.id + '.' + i"
                                     [photoswipeOptions]="{
                                                   index: i,
                                                   galleryUID: product.data.id
                                               }">

                                }
                                @if (productImage.video) {
                                <vimeo-player class="bg-col-w"
                                              [video-url]="productImage.video"
                                              [background]="true"
                                              [autoplay-in-viewport]="true"
                                              [loop]="true">
                                </vimeo-player>
                                }
                                @if(productImage.shopTheLook) {
                                <shop-this-look [content]="{
                                        shopThisLookTop: true,
                                        shopThisLookLeft: false,
                                        shopThisLookProductsSkus: productImage.shopTheLook
                                    }"></shop-this-look>
                                }
                                }
                            </div>
                            @if (productImage.alt_text) {
                            <p class="p-t-2 bg-col-w p3 _altText">{{productImage.alt_text}}</p>
                            }
                        </ng-template>
                        }
                    </swiper>
                </div>
                <!-- custom dots -->
                <swiper-dots class="product-gallery-swiper-dots wrap pos-absolute bottom-0 left-0 m-b-2 z-2"
                             [swiperRef]="swiper"></swiper-dots>
            </div>
        </div>
        }

        <photoswipe-lightbox [photoswipeOptions]="photoswipeOptions"
                             (photoswipeStateChange)="onPhotoswipeStateChange($event)"
                             (photoswipeChanged)="onPhotoswipeChanged($event)">
            <ng-template #photoswipeThumbnailTpl
                         let-item
                         let-i="index"
                         let-photoswipe="photoswipe">
                @if (item.source) {
                <div class="pos-relative bg-col-5 pswp__thumb"
                     [class.is-active]="item === photoswipe?.currItem"
                     (click)="photoswipe?.goTo(i)">
                    <img class="fill"
                         [image]="item.source"
                         [attr.alt]="product.data!.name">
                </div>
                }
            </ng-template>

            <ng-template #photoswipeIconCloseTpl>
                <div class="col-12 flex flex-middle">
                    <i class="icon-chevron inline-flex rotate-180 va-m"
                       [style.fontSize.rem]="1.5"
                       aria-hidden="true"></i>
                    <span class="inline-block m-l-1 overflow-hidden p1 no-wrap"
                          [style.marginTop.px]="2">{{'Close zoom' |
                        translate}}</span>
                </div>
            </ng-template>

            <ng-template #photoswipeIconPrevTpl></ng-template>

            <ng-template #photoswipeIconNextTpl></ng-template>

            <ng-template #photoswipeIconZoomTpl></ng-template>
        </photoswipe-lightbox>
    </div>
    @if (product.data && product.data.features_section?.length) {
    <features-section *ifSize="'XL'"
                      [product]="product"></features-section>
    }
</div>